module.exports = __webpack_public_path__ + "img/22.167b6e07.png";